import { useIntl } from 'react-intl';
import { TranslationKeys } from '../translations';
import { useCallback } from 'react';
import { useSnakeBar } from './useSnakeBar';

export const useProcessCustomBackendError = () => {
  const intl = useIntl();

  const { showSnakeBar, showErrorSnakeBar } = useSnakeBar();

  return useCallback(
    (error: any, method?: string) => {
      const errorMessage = error?.response?.data?.['hydra:description'] || error?.message;
      const translationKey = TranslationKeys[errorMessage as keyof typeof TranslationKeys];

      if (translationKey) {
        showSnakeBar({
          severity: 'error',
          method,
          message: intl.formatMessage({ id: translationKey }),
        });
        return;
      }

      showErrorSnakeBar({
        method,
      });
    },
    [intl, showSnakeBar, showErrorSnakeBar],
  );
};
